import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsConfirmationDialog from "app/common/GlobitsConfirmationDialog";
import { getDepartmentsUser, isAdmin } from "app/common/LocalFunction";
import { pagingDepartment } from "app/services/DepartmentService";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";

export default function SelectDefaultDepartment({ variant = "standard", isMobile }) {
  const listDepartmentByUser = getDepartmentsUser();
  //console.log("listDepartmentByUser", listDepartmentByUser);
  const defaultDepartment = localStorage.getItem("defaultDepartment") || null;

  const [openAlert, setOpenAlert] = useState(false);

  useEffect(() => {
    if (
      !defaultDepartment ||
      defaultDepartment === "null" ||
      // nếu mặc định trong localStorage không có trong tài khoản thì bỏ mặc định
      (listDepartmentByUser?.length > 0 &&
        defaultDepartment !== "" &&
        !listDepartmentByUser?.some(
          (f) => f?.id === JSON.parse(defaultDepartment)?.id
        ))
    ) {
      if (listDepartmentByUser?.length > 0) {
        localStorage.setItem(
          "defaultDepartment",
          JSON.stringify(listDepartmentByUser?.[0])
        );
        window.dispatchEvent(new Event("localStorageUpdated"));
      } else {
        setOpenAlert(true);
      }
    } else if (
      isAdmin &&
      (!defaultDepartment || defaultDepartment === "null")
    ) {
      setOpenAlert(true);
    }
  }, [defaultDepartment]);
  const isAdmins = isAdmin()
  return (
    <>
      <GlobitsConfirmationDialog
        open={openAlert}
        onConfirmDialogClose={() => setOpenAlert(false)}
        title="Thông báo"
        text="Bạn chưa chọn cơ sở làm việc"
        cancel="Đóng"
      />
      <Formik
        enableReinitialize
        initialValues={{
          defaultDepartment: JSON.parse(defaultDepartment),
        }}
      >
        {({ setFieldValue }) => {
          return (
            <Form
                style={{ minWidth: isMobile ? 225 : 240, gap: 4 }}
              className="flex flex-middle"
            >
              {!isMobile &&  (
                <label style={{ color: "black", whiteSpace: "nowrap" }}>
                  Cơ sở:{" "}
                </label>
              )}
              {!isAdmins? (
                <GlobitsAutocomplete
                  name="defaultDepartment"
                  options={listDepartmentByUser}
                  displayLabel="name"
                  placeholder="Cơ sở"
                  // className={`${!variant === "outlined" ? "outlined-paging" : ""
                  //   } select-default-store`}
                  // variant={variant}
                  onChange={(_, value) => {
                    setFieldValue("defaultDepartment", value);
                    localStorage.setItem(
                      "defaultDepartment",
                      JSON.stringify(value)
                    );
                    window.dispatchEvent(new Event("localStorageUpdated"));
                  }}
                />
              ) : (
                <GlobitsPagingAutocomplete
                  variant={variant}
                  className={`${variant === "outlined" ? "outlined-paging" : ""
                    } select-default-store`}
                  name="defaultDepartment"
                  // label="Cơ sở"
                  api={pagingDepartment}
                  fullWidth
                  clearOptionOnClose
                  placeholder="Cơ sở"
                  onChange={(_, value) => {
                    setFieldValue("defaultDepartment", value);
                    localStorage.setItem(
                      "defaultDepartment",
                      JSON.stringify(value)
                    );
                    window.dispatchEvent(new Event("localStorageUpdated"));
                  }}
                />
              )}
            </Form>
          );
        }}
      </Formik>
    </>
  );
}
